import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func, bool } from 'prop-types'

import Modal from 'Pods/Shared/Modal/Modal'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function DeleteConfirmModal({
  itemType = 'item',
  itemName = '',
  isSubmitDisabled = false,
  onSubmit: handleSubmit,
  onCancel: handleCancel,
}) {
  const t = useTranslation()
  const itemTypeLabel = t(`shared.deleteConfirmModal.itemTypes.${itemType}`)
  const header = t('shared.deleteConfirmModal.header', { itemType: itemTypeLabel })

  const footer = (
    <>
      <Button type="secondary" size="small" actionType="button" onClick={handleCancel}>
        {t('shared.deleteConfirmModal.cancel')}
      </Button>
      <Button
        type="primary-warning"
        size="small"
        actionType="button"
        customClass="delete-confirm-modal__delete"
        disabled={isSubmitDisabled}
        onClick={handleSubmit}
      >
        {t('shared.deleteConfirmModal.submit')}
      </Button>
    </>
  )

  return (
    <Modal
      header={header}
      ariaLabel={header}
      width="small"
      footer={footer}
      customClass="delete-confirm-modal"
      onClose={handleCancel}
    >
      <span className="cgt-body-md">
        {itemName
          ? t('shared.deleteConfirmModal.bodyNamed', { itemName })
          : t('shared.deleteConfirmModal.bodyGeneric', { itemType: itemTypeLabel })}
      </span>
    </Modal>
  )
}

DeleteConfirmModal.propTypes = {
  itemType: string,
  itemName: string,
  isSubmitDisabled: bool,
  onSubmit: func.isRequired,
  onCancel: func.isRequired,
}

export default DeleteConfirmModal
